import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import useSWR from 'swr'

export function useCampaignDetailsByLeadSource(leadSource: string, statType: "source" | "campaign" | null) {
   const response = useSWR(
      leadSource ? [QUERY_KEYS.CAMPAIGN_DETAILS_BY_ID, leadSource] : null,
      () =>
         leadSource ? CampaignService.getCampaignByLeadSource(leadSource, statType) : null
   )

   return {
      ...response,
   }
}
